import { getEmbed, renderFrame } from '../lib/embed';

/**
 * Inline player for tutorial articles.
 *
 * The markup ships as a poster facade — the cover image plus a play button —
 * so a page with a video costs nothing from YouTube/Vimeo until someone
 * actually presses play. The click swaps the facade for the real player in
 * place rather than opening the landing page's modal: on a tutorial you want
 * the video and the written steps on screen at the same time.
 */
export function initArticleVideo(): void {
  const players = document.querySelectorAll<HTMLElement>('[data-article-video]');
  if (!players.length) return;

  players.forEach((player) => {
    const stage = player.querySelector<HTMLElement>('[data-article-video-stage]');
    const button = player.querySelector<HTMLButtonElement>('[data-article-video-play]');
    const url = player.dataset.articleVideo ?? '';
    if (!stage || !button || !url) return;

    const embed = getEmbed(url);
    if (!embed) return;

    button.addEventListener(
      'click',
      () => {
        stage.innerHTML = renderFrame(embed);
        player.classList.add('is-playing');
      },
      { once: true },
    );
  });
}
